<template>
  <div>
    <slot
      :currentPage="currentPage"
      :currentPageData="currentPageData"
      :setPageSize="setPageSizeAndEmit"
      :setCurrentPage="setCurrentPageAndEmit"
      :total="count"
      :pageSizes="pageSizes"
      :pageSize="pageSize"
    />
  </div>
</template>

<script>
import pagination from '@/mixins/pagination';
export default {
  name: 'PaginationWrapper',

  mixins: [pagination],

  props: {
    isLoading: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      currentPage: 1,
      pageSize: 10,
    };
  },
  computed: {
    currentPageData() {
      const offsetStart = this.pageSize * (this.currentPage - 1);
      const offsetEnd = offsetStart + this.pageSize;

      return this.data.slice(offsetStart, offsetEnd);
    },

    count() {
      return this.data.length;
    },

    pageSizes() {
      return this.getPageSizes(this.count);
    },
  },
  watch: {
    data(val, prevVal) {
      if (val.length !== prevVal.length) {
        this.currentPage = 1;
      }
    },
  },
  methods: {
    setCurrentPageAndEmit(page) {
      this.$emit('current-change', page);

      this.currentPage = page;
    },

    setPageSizeAndEmit(size) {
      this.$emit('size-change', size);

      this.pageSize = size;
      this.setCurrentPageAndEmit(1);
    },
  },
};
</script>

<style lang="scss">
.with-pagination {
  &__pagination {
    margin-top: $global-margin * 2;
  }
}
</style>
